export { default } from "./useLazyClassroomGetList";
